import { __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import TextField from '../TextField/index.js';

var EmailField = function EmailField(props) {
  return React.createElement(TextField, __assign({
    type: "email",
    placeholder: "e.g. jdoe@gmail.com"
  }, props));
};

export default EmailField;
//# sourceMappingURL=index.js.map
